function videoPlay(wrapper, local_video) {
    if (local_video) {
        var localVideo = wrapper.querySelector('.js-videoBannerIframe');
        wrapper.classList.add('videoWrapperActive');
        localVideo.play();
    } else {
        var iframe = wrapper.querySelector('.js-videoBannerIframe');
        var src = iframe.getAttribute('src') + '&autoplay=1';
        wrapper.classList.add('videoWrapperActive');
        iframe.setAttribute('src',src);
    }
}
function videoStop(wrapper, local_video) {
    if (local_video) {
        var localVideo = wrapper.querySelector('.js-videoBannerIframe');
        wrapper.classList.remove('videoWrapperActive');
        localVideo.pause();
    } else {
        let iframe = wrapper.querySelector('.js-videoBannerIframe');
        let src = iframe.getAttribute("src");
        if (src.includes("&autoplay=1")) {
            wrapper.classList.remove('videoWrapperActive');
            iframe.setAttribute('src', src.replace('&autoplay=1', ''));
        }
    }
}

let autoPlayVideo = (topSection, bannerItem, local_video) => {
    const videoTop = document.querySelector(topSection);

    const observer = new window.IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
            document.querySelector(bannerItem).hidden = true
            if (local_video) {
                videoPlay(videoTop, true);
            } else {
                videoPlay(videoTop, false);
            }
            return
        }
            document.querySelector(bannerItem).hidden = false
            videoStop(videoTop);
        }, {
            root: null,
            threshold: 1, // set offset 0.1 means trigger if atleast 10% of element in viewport
        })

        observer.observe(videoTop);
}